<template>
    <div>
        <div class="col-md-3 col-xs-12 p-right-5" @click="togglePaymentDetailsPopup(`payment-details-${modalInvoice?paymentDetail.id:index}`)" v-if="!isMobile">
            {{ paymentDetail.received_formatted_date }}
        </div>

        <div class="col-md-3 col-xs-6" @click="togglePaymentDetailsPopup(`payment-details-${modalInvoice?paymentDetail.id:index}`)">
            {{ paymentDetail.payment_type }}
        </div>

        <div class="col-md-5 col-xs-6 col-xs-6 p-left-0 p-right-0" @click="togglePaymentDetailsPopup(`payment-details-${modalInvoice?paymentDetail.id:index}`)">
            <div :class="{'float-right':isMobile}">
                <div :class="{'col-md-2 col-xs-3 mobile-p-left-4':true }">
                    {{ currency.currency_symbol }}{{ paymentDetail.total_paid_with_tip_and_surcharge }}
                </div>
            <!--  For the mobile view only  -->
                <div class="col-xs-1 cursor-pointer float-right" v-if="isMobile">
                    <i :ref="'toggleIconForMoreInfo_'+index" class="fa fa-chevron-right"></i>
                </div>
            </div>
            <div class="col-md-10 col-xs-12 mobile-p-left-4" v-if="!isMobile">
                                 <span
                                     :class="{'status-label labels-font font-family-Roboto float-right':true,[statusLabelColorClass]:statusLabelColorClass}"
                                     :style="this.paymentDetail.type === 'refund' ? { 'font-size': '12px' } : {}">
                                   {{ statusLabel }}
                                 </span>
            </div>
        </div>

        <!--  For the mobile view only  -->
        <div class="col-xs-12 position-relative bottom-8" v-if="isMobile">
            <span :class="{'status-label labels-font font-family-Roboto':true,[statusLabelColorClass]:statusLabelColorClass}">{{ statusLabel }}</span>
        </div>

        <div :class="{'col-md-1 col-xs-3 mobile-position':true , 'float-right':isMobile}" @click="togglePaymentDetailsPopup(`payment-details-${modalInvoice?paymentDetail.id:index}`)" v-if="!isMobile">
            <div class="col-md-6 col-xs-1 cursor-pointer">
                <i :ref="'toggleIconForMoreInfo_'+index" class="fa fa-chevron-right position-relative top-8"></i>
            </div>
        </div>

  <payment-details-modal :id="modalInvoice?paymentDetail.id:index "
                         :can-see-customer="canSeeCustomer"
                         :logged-user="loggedUser"
                         :payment-detail="paymentDetail"
                         :booking-invoice="bookingInvoice"
                         :status-label="statusLabel"
                         @delete="emitDelete"
                         @close-modal="isPaymentDetailsVisible = false"
                         :is-visible="isPaymentDetailsVisible"
                         :calculate-prices-method="calculatePricesMethod"
                         :get-payments-method="getPaymentsMethod"
                         :status-label-color-class="statusLabelColorClass"
                         :currency="currency"></payment-details-modal>

        <div :class="{'col-md-12 col-xs-12':true }" v-if="index !== length-1">
            <hr :class="{'m-top-0 m-bottom-0': isMobile}"/>
        </div>
    </div>
</template>

<script>
import PaymentDetailsModal from "@/modules/Payment/components/PaymentDetailsModal.vue";
import {EventBus} from "@/events/event-bus";
export default {
    name: "PaymentRow",
    props: {
    paymentDetail: {
      required: true
    },
      loggedUser: {
        required: false,
      },
      canSeeCustomer: null,
     calculatePricesMethod:Function,
        getPaymentsMethod:Function,
     index: {
      required: true
    },
        modalInvoice:false,
        length: {
            required: true
        },

        bookingInvoice: {
            required: true
        },
        currency: {
            required: true
        },
    },
    components: {PaymentDetailsModal},
    data() {
        return {
            isPaymentDetailsVisible: false,
        }
    },
    computed: {
        statusLabel() {
            if (this.paymentDetail.type==='refund'){
                return this.paymentDetail.is_approved ? 'Approved refund' : (this.paymentDetail.is_rejected?'Declined refund':'Pending approval refund');
            }else{
                return (this.paymentDetail.is_refunded ?'Refunded': (this.paymentDetail.is_approved ? 'Approved' : (this.paymentDetail.is_rejected?'Declined':(this.paymentDetail.is_pre_auth?'Authorized': 'Pending approval'))) )+ (this.paymentDetail.pre_auth_status ===1 ? ' Pre-auth':'');
            }
       },
        statusLabelColorClass() {
            if (this.paymentDetail.type==='refund'){
                return this.paymentDetail.is_approved ? 'gray-color' :'orange-color';
            }else{
                return this.paymentDetail.is_refunded ?'gray-color': (this.paymentDetail.is_approved ? 'green-color' : this.paymentDetail.is_rejected?'red-color':'orange-color');
            }
        },
        isMobile() {
            return this.getWidth() <= 768;
        },
    },
    methods: {
        togglePaymentDetailsPopup(id) {
            this.isPaymentDetailsVisible = true;
            $(`#${id}`).modal('show');
            // $(`#${id}`).css('z-index','9999');
        },
        addEventListeners(){

        },
        emitDelete() {
            // Emitting an event for the parent component
            this.$emit('delete-payment');
        },
        getWidth() {
            let xWidth = null;
            if (window.screen != null)
                xWidth = window.screen.availWidth;

            if (window.innerWidth != null)
                xWidth = window.innerWidth;

            if (document.body != null)
                xWidth = document.body.clientWidth;

            return xWidth;
        },
    },
    mounted() {
        this.addEventListeners()
    }
}
</script>

<style scoped>
.status-label {
    color: #FFFFFF !important;
    border-radius: 100px !important;
    padding: 2px 8px 4px 8px !important;
}

.border-style {
    border-right: 1px solid;
    border-color: #EAECEE;
}

.labels-font {
    font-size: 14px;
    font-weight: 600;
    color: #2E4051;
}

.font-family-Roboto {
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
    color: #2E4051;
}

.pair_btn_new_uniq .create-btn {
    border: none !important;
}

.cursor-pointer {
    cursor: pointer;
}

.has-error .form-control {
    border-color: #a94442 !important;
}

.modal-header.new-design .modal-title {
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 24px;
    color: #2E4051;
    display: inline;
}

.bottom-8{
    bottom: 8px;
}
@media (max-width: 768px) {
    .mobile-p-left-4 {
        padding-left: 4px;
    }

    .mobile-position {
        position: relative;
        bottom: 76px;
        left: 30px;
    }
    .m-top--50 {
        margin-top: -50px;
    }
}

@media (min-width: 768px) and (max-width: 1023px) {
    .mobile-position {
        left: 215px;
    }
}
</style>